/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
// Fix dropdown nav-bar in modalità inline per Warehouse v7.0.1
document.addEventListener('DOMContentLoaded', function() {
  var navItems = document.querySelectorAll('.nav-bar__item a[aria-haspopup="true"]');
  
  navItems.forEach(function(trigger) {
    var dropdown = document.getElementById(trigger.getAttribute('aria-controls'));
    if (!dropdown) return;

    // Hover
    trigger.parentElement.addEventListener('mouseenter', function() {
      dropdown.setAttribute('aria-hidden', 'false');
      trigger.setAttribute('aria-expanded', 'true');
    });

    trigger.parentElement.addEventListener('mouseleave', function() {
      dropdown.setAttribute('aria-hidden', 'true');
      trigger.setAttribute('aria-expanded', 'false');
    });

    // Click (fallback)
    trigger.addEventListener('click', function(e) {
      var isOpen = trigger.getAttribute('aria-expanded') === 'true';
      if (!isOpen) {
        e.preventDefault();
        dropdown.setAttribute('aria-hidden', 'false');
        trigger.setAttribute('aria-expanded', 'true');
      }
    });
  });
});
// Fix overflow dropdown nav-bar
(function() {
  var style = document.createElement('style');
  style.textContent = [
    '.nav-bar { overflow: visible !important; }',
    '.nav-bar__inner { overflow: visible !important; }',
    '.nav-dropdown { overflow: visible !important; max-width: none !important; }',
    '.nav-bar__item { position: relative !important; }',
    '.nav-dropdown.nav-dropdown--floating { left: 0 !important; }'
  ].join(' ');
  document.head.appendChild(style);
})();
// Fix z-index dropdown sopra il contenuto
(function() {
  var style2 = document.createElement('style');
  style2.textContent = [
    '.nav-bar { position: relative; z-index: 100 !important; }',
    '.nav-dropdown { z-index: 200 !important; position: absolute !important; }',
    '#shopify-section-header { z-index: 200 !important; }',
    '.shopify-section__header { z-index: 200 !important; }'
  ].join(' ');
  document.head.appendChild(style2);
})();
// Fix: z-index bilanciato per dropdown sopra immagini ma sotto la ricerca
(function() {
  var style3 = document.createElement('style');
  style3.textContent = [
    '.nav-dropdown { z-index: 80 !important; }',
    '.nav-bar { z-index: 70 !important; overflow: visible !important; }',
    '.shopify-section-header, #shopify-section-header { z-index: 60 !important; overflow: visible !important; }',
    'predictive-search, .predictive-search, .search-modal { z-index: 99999 !important; }',
    'body > * { z-index: auto; }',
    '.hero, .slideshow, .index-section, [class*="hero"], [class*="slideshow"], [class*="banner"] { z-index: 1 !important; }'
  ].join(' ');
  document.head.appendChild(style3);
})();
// Fix nav-dropdown--fixed che taglia le voci
(function() {
  var style4 = document.createElement('style');
  style4.textContent = [
    '.nav-dropdown--fixed { height: auto !important; max-height: none !important; overflow: visible !important; clip: auto !important; clip-path: none !important; }',
    '.nav-dropdown--floating { height: auto !important; max-height: none !important; overflow: visible !important; clip: auto !important; clip-path: none !important; }',
    '.header__desktop-nav { overflow: visible !important; height: auto !important; }'
  ].join(' ');
  document.head.appendChild(style4);
})();

